<template>

  <v-layout row="row" wrap="wrap">
    <v-flex xs8="xs8">
      <v-text-field v-model="d" label="Date" placeholder="dd/mm/yyyy" :error="dateError"></v-text-field>
    </v-flex>
    <v-flex xs4="xs4">
      <v-text-field v-model="t" label="Time" placeholder="hh:mm" :error="timeError"></v-text-field>
    </v-flex>
  </v-layout>

</template>

<script>
export default {
  name: 'DateSearchInput',
  props: ['value'],
  data () {
    return {
      d: '',
      t: ''
    }
  },
  computed: {
    dateError () {
      if (this.d === '') {
        return false
      }

      const date = /(\d\d?)\/(\d\d?)\/(\d{4})/.exec(this.d)

      if (date === null) {
        return true
      }

      const day = date[1]
      const month = date[2]
      const year = date[3]

      // Basic day value check
      if (day < 1 || day > 31) {
        return true
      }

      // Check month value
      if (month < 1 || month > 12) {
        return true
      }

      const monthDays = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]

      // Check if Feb 30 on bisextil year
      if ((year % 4 === 0) && month === 2 && day === 30) {
        return false
      }

      // Check if day fit in month
      if (day > monthDays[month - 1]) {
        return true
      }
      return false
    },

    timeError () {
      if (this.t === '') {
        return false
      }

      const time = /(\d\d?):(\d\d)/.exec(this.t)

      if (time === null) {
        return true
      }

      const hours = time[1]
      const minutes = time[2]

      // Check hours value
      if (hours < 0 || hours > 23) {
        return true
      }

      // Check minutes value
      if (minutes < 0 || minutes > 59) {
        return true
      }
      return false
    }
  },
  methods: {
    update () {
      if (this.dateError || this.timeError) {
        return
      }

      if (this.d === '' && this.t === '') {
        this.$emit('input', null)
        return
      }

      const date = /(\d\d?)\/(\d\d?)\/(\d{4})/.exec(this.d)
      let time = /(\d\d?):(\d\d)/.exec(this.t)

      if (this.t === '') {
        time = ['00:00', '00', '00']
      }

      const day = date[1]
      const month = date[2]
      const year = date[3]
      const hours = time[1]
      const minutes = time[2]

      this.$emit('input', new Date(year, month - 1, day, hours, minutes).toISOString())
    },

    refresh () {
      const date = new Date(this.value)
      this.refreshDate(date)
      this.refreshTime(date)
    },

    refreshDate (date) {
      if (this.d !== '') {
        return
      }
      const day = date.getDate().toString().padStart(2, '0')
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const year = date.getFullYear()

      this.d = `${day}/${month}/${year}`
    },

    refreshTime (date) {
      if (this.t !== '') {
        return
      }
      const hours = date.getHours()
      const minutes = date.getMinutes().toString().padStart(2, '0')

      this.t = `${hours}:${minutes}`
    }
  },
  watch: {
    d () {
      this.update()
    },
    t () {
      this.update()
    },
    value () {
      if (this.value) {
        this.refresh()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/DateSearchInput.vue